
<app-admin-menu></app-admin-menu>
<div class="content-area h-full w-full">
    <!-- <p-card> -->
        <router-outlet>
        </router-outlet>
    <!-- </p-card> -->
</div>
